import useFetcher from 'hooks/useFetcher/useFetcher';
import { ServiceTypes } from 'hooks/useFetcher/interfaces';
import { stringifyUrl, getRequest } from 'utils';
import { Properties } from 'types';

export interface VoipItem {
  id: number;
  name: string;
}

export interface VoipListParams {
  ordering?: string;
  search?: string;
  page?: number;
  per_page?: number;
}

export interface VoipListResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: VoipItem[];
}

export const useVoipAPI = (): Properties => {
  const fetcher = useFetcher(ServiceTypes.CRM);

  return {
    getVoipList: ({ queryKey: [, query] }: { queryKey: [string, VoipListParams?] }) => {
      return fetcher(stringifyUrl('/voip', query), getRequest) as Promise<VoipListResponse>;
    },

    loginVoip: (id: number) => {
      return fetcher(`/voip/${id}/login`, {
        request: {
          method: 'POST',
        },
      }) as Promise<VoipItem>;
    },
  };
};
